import { render } from "./header-logo.svg?vue&type=template&id=86818a4e?inline"
const script = {}

import exportComponent from "/Users/mrooze01/Pointer/projecten/knd/projects/2022/factcheck-gemeenteraadsverkiezingen/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__